// Import packages
import React, {Component} from "react";
import {connect} from "react-redux";
import {DatePicker, Switch} from "antd";

// Import Styles
// import '../../assets/styles/containerStyles/appended-blog-section.scss';
// import '../../assets/styles/containerStyles/blog/blog-add-edit.scss';
import '../../assets/styles/containerStyles/page-add-edit.scss';
import '../../assets/styles/components/medias-list-wrapper.scss';

// Import components
import PageWrapper from '../../components/pageContentViews/pageWrapper'
import {InputGroup} from "../../components/uiElements/inputGroup";
import {LinkButton} from "../../components/buttons/buttons";
import {LanguageTabs} from "../../components/uiElements/Tabs";
import {Editor} from "../../components/uiElements/Editor";
import MediaSelectorModal from "../../components/media/MediaSelectorModal";
import {MediaFileCard} from "../../components/media/MediaFileCard";


// Import utils
import {mapStateToProps} from "../../redux/mapStateToProps";
import {
    changeStateField, disabledEndDate,
    getInputValues,
    getPatchReqData,
    getPostReqData,
    getTranslatableInputValues,
    getTranslationData,
    initTranslations,
} from "../../utils/helperFunctions";
import {AddBlog, GetBlogById, UpdateBlog,} from "../../redux/actions";
import {validateTranslations} from "../../utils/validateTranslations";
import {ACCEPT_IMAGE_TYPES, ACCEPT_VIDEO_TYPES} from "../../constants/acceptedTypes";
import {MEDIA_MODAL_TYPES,} from "../../constants/constTypes";
import Nestable from "react-nestable";
import {MaterialIcon} from "../../components/utils/Icon";
import dayjs from "dayjs";
import {BLOG_TYPES} from "../../constants/constTypes";

const BLOG_SOCIAL_ITEMS = {
    FACEBOOK: {
        key: "FACEBOOK",
        title: "FACEBOOK"
    },
    TWITTER: {
        key: "TWITTER",
        title: "TWITTER"
    },
    LINKEDIN: {
        key: "LINKEDIN",
        title: "LINKEDIN"
    },
    INSTAGRAM: {
        key: "INSTAGRAM",
        title: "INSTAGRAM"
    },
    TIKTOK: {
        key: "TIKTOK",
        title: "TIKTOK"
    },
    TELEGRAM: {
        key: "TELEGRAM",
        title: "TELEGRAM"
    },
}

const blogSocialOptions = Object.keys(BLOG_SOCIAL_ITEMS).map(key => {
    return {
        id: BLOG_SOCIAL_ITEMS[key].key,
        name: BLOG_SOCIAL_ITEMS[key].title,
    }
})

const blogTypeOptions = Object.keys(BLOG_TYPES).map(key => {
    return {
        id: BLOG_TYPES[key].key,
        name: BLOG_TYPES[key].title,
    }
})

class AddEditBlog extends Component {
    constructor(props) {
        super(props);
        this.translationsFields = [
            'title',
            'subTitle',
            'description',
        ];
        this.state = {
            fieldsData: {
                translations: initTranslations(this.translationsFields, props.activeLanguages),
                mediaMain: undefined,
                video: undefined,
                youtubeLink: '',
                medias: [],
                slug: '',
                hashtags: '',
                type: undefined,
                date: dayjs(),
                isHidden: false,


                socials: [],
            },
            errors: {},
            errorsTabs: [],
            isEditing: !!props?.id,
            languageTab: props.mainLanguage,
            mediaModalType: null,
            requestLoading: false,
        };
        this.updatedDataMap = new Map();
        this.currentData = null;
        this.getPostReqData = getPostReqData.bind(this);

        this.toggleMediaModal = changeStateField.bind(this, 'mediaModalType');
        this.changeLanguageTab = changeStateField.bind(this, 'languageTab');
        this.getInputValues = getInputValues.bind(this);
        this.getPatchReqData = getPatchReqData.bind(this);
        this.getTranslationValues = getTranslatableInputValues.bind(this);

        this.checkMediaListDifferent = this.checkMediaListDifferent.bind(this);
        this.onMediaPositionChange = this.onMediaPositionChange.bind(this);
        this.mediaCardWrapper = this.mediaCardWrapper.bind(this);
        this.getMedia = this.getMedia.bind(this);
        this.deleteMedia = this.deleteMedia.bind(this);

        this.addSocialItem = this.addSocialItem.bind(this);
        this.deleteSocial = this.deleteSocial.bind(this);
        this.onSocialPositionChange = this.onSocialPositionChange.bind(this);

        this.addEditBlog = this.addEditBlog.bind(this);
    }

    async componentDidMount() {
        const {isEditing, fieldsData} = this.state;
        if (isEditing) {
            const translationsData = {};
            const editingData = await this.props.GetBlogById(this.props.id)
            if (editingData) {
                Object.keys(fieldsData.translations).forEach(key => {
                    const trItem = editingData?.translations?.find(item => item.language === key);
                    translationsData[key] = {
                        ...fieldsData.translations[key],
                        title: trItem?.title || '',
                        subTitle: trItem?.subTitle || '',
                        description: trItem?.description || '',
                    };
                });
            }
            const initStateData = {
                translations: translationsData,
                mediaMain: editingData?.mediaMain,
                video: editingData?.video,
                youtubeLink: editingData?.youtubeLink || '',
                medias: editingData?.medias || [],
                slug: editingData?.slug || '',
                hashtags: editingData?.hashtags || '',
                type: editingData?.type || undefined,
                date: editingData?.date ? dayjs(editingData?.date) : dayjs(),
                isHidden: editingData?.isHidden,
                // socials: Array.isArray(editingData.socials) ? editingData.socials : [],
            }
            this.currentData = JSON.parse(JSON.stringify(initStateData));
            this.setState({
                fieldsData: initStateData,
            });
        }
    }

    getMedia(mediaArray, mediaType) {
        const {fieldsData, errors, isEditing, mediaModalType} = this.state;
        if (isEditing) {
            if (mediaType === MEDIA_MODAL_TYPES.MEDIA_MAIN) {
                this.currentData?.[mediaModalType]?.id !== mediaArray[0]?.id
                    ? this.updatedDataMap.set(mediaModalType, mediaArray[0]?.id)
                    : this.updatedDataMap.delete(mediaModalType);
            } else {
                this.checkMediaListDifferent(mediaArray)
            }

        }
        this.setState({
            fieldsData: {
                ...fieldsData,
                [mediaModalType]: mediaType === MEDIA_MODAL_TYPES.MEDIA_MAIN
                    ? mediaArray[0] : mediaArray,
            },
            errors: {
                ...errors,
                [mediaModalType]: false
            }
        })
    }

    deleteMedia(type, id) {
        const {fieldsData, isEditing} = this.state;
        let medias = fieldsData.medias.filter(m => m.id !== id);

        if (isEditing) {
            if (type === 'medias') {
                this.checkMediaListDifferent(medias)
            } else {
                this.currentData?.[type] ?
                    this.updatedDataMap.set(type, null) :
                    this.updatedDataMap.delete(type);
            }

        }
        this.setState({
            fieldsData: {
                ...fieldsData,
                [type]: type === 'medias' ? medias : null
            }
        })
    }

    checkMediaListDifferent(currMedias) {
        let result = false;
        const initMedias = this.currentData.medias;
        if (!Array.isArray(currMedias) || (currMedias?.length !== initMedias.length)) {
            result = true;
        } else {
            currMedias.forEach((item, index) => {
                if (initMedias[index]?.id !== item?.id) {
                    result = true;
                }
            })
        }
        result ? this.updatedDataMap.set('medias', currMedias?.map(m => m.id))
            : this.updatedDataMap.delete('medias');
    }

    onMediaPositionChange(items) {
        const {fieldsData, isEditing} = this.state;
        const medias = items.map(item => item.media);
        if (isEditing) {
            // this.checkMediaListDifferent(medias)
            this.updatedDataMap.set('medias', medias?.map(m => m.id))
        }
        this.setState({
            fieldsData: {
                ...fieldsData,
                medias: medias
            }
        })
    }

    mediaCardWrapper(data) {
        return <MediaFileCard item={data?.item?.media}
                              customDelete={this.deleteMedia.bind(this, 'medias', data?.item?.media?.id)}/>
    }


    addSocialItem = () => {
        const {isEditing,} = this.state
        const socials = [{
            type: null,
            link: ''
        },
            ...this.state.fieldsData.socials]
        if (isEditing) {
            this.updatedDataMap.set('socials', socials)
        }
        this.setState({
            fieldsData: {
                ...this.state.fieldsData,
                socials: socials
            }
        })
    }

    deleteSocial(index) {
        const {isEditing, fieldsData, errors} = this.state;
        const socials = fieldsData.socials.filter((_, pos) => pos !== index)
        if (isEditing) {
            this.updatedDataMap.set('socials', socials)
        }
        this.setState({
            fieldsData: {
                ...fieldsData,
                socials: socials
            },
            errors: {
                ...errors,
                socials: {}
            }
        })
    }

    onSocialPositionChange = (items) => {
        console.log('items', items)
        const {fieldsData, isEditing} = this.state;
        const socials = items.map(item => item.social);
        if (isEditing) {
            this.updatedDataMap.set('socials', socials)
        }
        this.setState({
            fieldsData: {
                ...fieldsData,
                socials
            }
        })
    }

    getSocialValue = (index, value, name) => {
        const {fieldsData, isEditing} = this.state;

        const socials = this.state.fieldsData.socials.map((item, pos) => {
            return pos === index ? {
                ...item,
                [name]: value
            } : item
        })
        if (isEditing) {
            this.updatedDataMap.set('socials', socials)
        }
        this.setState({
            fieldsData: {
                ...this.state.fieldsData,
                socials: socials
            }
        })
    }

    socialItem = (data) => {
        const {errors} = this.state
        const {index, social} = data.item
        return <div className={'social-item'}>
            <div className={`type-select ${errors?.socials?.[index + 'icon'] ? 'error' : ''}`}>
                <InputGroup inputType="selectCustom"
                            placeholder="Էջ"
                            label="Էջ"
                            name="type"
                            showSearch={false}
                            value={social?.type}
                            onChange={({value}) => this.getSocialValue(index, value, 'type')}
                            options={blogSocialOptions}/>
            </div>
            <InputGroup inputType="input"
                        type="text"
                        label="Հղում"
                        placeholder="Հղում"
                        name="link"
                        value={social?.link}
                        maxLength={256}
                        error={errors?.socials?.[index + 'link']}
                        onChange={({value}) => this.getSocialValue(index, value, 'link')}/>
            <div className={`delete-btn`} onClick={() => this.deleteSocial(index)}>
                <MaterialIcon icon="delete"/>
            </div>
        </div>
    }

    getSocialNestableItems = () => {
        const {fieldsData} = this.state
        const {socials} = fieldsData
        const items = [];
        socials && !!socials.length && socials.forEach((item, index) => {
            items.push({
                id: index,
                index: index,
                social: item
            })
        });
        return items;
    }

    async addEditBlog() {
        await this.setState({
            requestLoading: true
        });
        const {fieldsData} = this.state;
        const {
            translations,
            mediaMain,
            date,
            type,
            coverMedia,
            medias,
            socials,
            youtubeLink,
            slug,
            isHidden
        } = fieldsData;
        const translationRequiredFields = ['title']
        const validationTr = validateTranslations(translations, translationRequiredFields)
        let result = validationTr.result;
        const errors = {...validationTr.errors};

        // if (!mediaMain) {
        //     errors.mediaMain = true;
        //     result = false;
        // }

        // if (!video) {
        //     errors.video = true;
        //     result = false;
        // }

        if (!slug) {
            errors.slug = true;
            result = false;
        }
        if (!type) {
            errors.type = true;
            result = false;
        }
        if (!date) {
            errors.date = true;
            result = false;
        }
        // if (type === BLOG_TYPES.VIDEO.key && !youtubeLink) {
        //     errors.youtubeLink = true;
        //     result = false;
        // }
        errors.socials = {}
        // socials && socials.forEach((social, index) => {
        //     if (!social.type) {
        //         errors.socials[index + 'type'] = true;
        //         result = false;
        //     }
        //     if (!social.link) {
        //         errors.socials[index + 'link'] = true;
        //         result = false;
        //     }
        // })
        console.log('result', result);
        if (result) {
            if (!this.state.isEditing) {
                const reqData = this.getPostReqData(fieldsData);
                reqData.isHidden = isHidden
                if (type !== BLOG_TYPES.VIDEO.key) {
                    reqData.youtubeLink = "";
                }
                console.log('reqData', reqData)
                this.props.AddBlog(reqData).finally(() => {
                    this.setState({requestLoading: false});
                })
            } else {
                const trData = getTranslationData(translations);
                const reqData = this.getPatchReqData(trData);
                if (type !== BLOG_TYPES.VIDEO.key) {
                    reqData.youtubeLink = "";
                }
                this.props.UpdateBlog(this.props.id, reqData)
                    .finally(() => {
                        this.setState({requestLoading: false});
                    });
            }
        } else {
            this.setState({
                requestLoading: false,
                errors: errors,
                errorsTabs: validationTr.errorsTabs
            })
        }
    }

    render() {
        const {
            fieldsData,
            errors,
            languageTab,
            mediaModalType,
            requestLoading,
            isEditing,
            errorsTabs
        } = this.state;
        const initData = this.currentData?.translations[languageTab] || {};
        const currentData = fieldsData.translations[languageTab] || {};
        const mediaItems = [];
        fieldsData.medias.forEach(media => {
            mediaItems.push({
                id: media?.id,
                media: media
            })
        });
        // let items = this.getSocialNestableItems();
        return <PageWrapper pageTitle={!isEditing ? 'Ավելացնել Բլոգ' : 'Փոփոխել Բլոգը'}>
            <section className="page-add-edit">
                <div className="fixed-top-right">
                    <label>{!fieldsData.isHidden ? "Ակտիվ " : "Ոչ ակտիվ "}</label>
                    <Switch checked={!fieldsData.isHidden}
                            onChange={(checked) => this.getInputValues({
                                name: "isHidden",
                                value: !checked,
                                haveChanges: this.currentData?.isHidden !== !checked
                            })}/>
                </div>
                <div className={"images-wrapper"}>
                    <div>
                        <div className="top-side">
                            <label>Նկար {/*<span className={'required-badge'}>*</span>*/}</label>
                            <LinkButton title="Ընտրել մեդիադարանից"
                                        className={`media-select-btn ${errors.mediaMain ? 'media-select-error' : ''}`}
                                        cb={this.toggleMediaModal.bind(this, 'mediaMain')}
                            />
                        </div>
                        {fieldsData?.mediaMain && <div className={'main-media'}>
                            <MediaFileCard item={fieldsData?.mediaMain}
                                           customDelete={() => this.deleteMedia("mediaMain")}
                            />
                        </div>}
                    </div>
                    <div>
                        <div className="top-side">
                            <label>Տեսանյութ</label>
                            <LinkButton title="Ընտրել մեդիադարանից"
                                        className={`media-select-btn ${errors.video ? 'media-select-error' : ''}`}
                                        cb={this.toggleMediaModal.bind(this, 'video')}
                            />
                        </div>
                        {fieldsData?.video && <div className={'main-media'}>
                            <MediaFileCard item={fieldsData?.video}
                                           customDelete={() => this.deleteMedia("video")}
                            />
                        </div>}
                    </div>
                </div>
                <div className={'medias-list-wrapper'}>
                    <div className={'label-and-action'}>
                        <label>Նկարներ</label>
                        <LinkButton title="Ընտրել Մեդիադարանից"
                                    className={`media-select-btn `}
                                    cb={this.toggleMediaModal.bind(this, 'medias')}/>
                    </div>
                    <section className={'items-wrapper'}>
                        {mediaItems.length ? <Nestable
                                items={mediaItems}
                                maxDepth={1}
                                onChange={this.onMediaPositionChange}
                                renderItem={this.mediaCardWrapper}
                            /> :
                            <p className={'empty-text'}>Նկարներ չկան</p>}
                    </section>
                </div>
                <InputGroup inputType="input"
                            type="text"
                            label="Slug"
                            placeholder="Slug"
                            name="slug"
                            value={fieldsData.slug}
                            initValue={this.currentData?.slug}
                            error={errors['slug']}
                            maxLength={50}
                            required={true}
                            onChange={this.getInputValues}/>
                <InputGroup inputType="selectCustom"
                            placeholder="Բլոգի տեսակ"
                            label="Բլոգի տեսակ"
                            name="type"
                            showSearch={false}
                            required={true}
                            error={errors['type']}
                            value={fieldsData?.type}
                            onChange={this.getInputValues}
                            options={blogTypeOptions}/>
                {fieldsData?.type === BLOG_TYPES.VIDEO.key && <InputGroup inputType="input"
                                                                          type="text"
                                                                          label="Youtube Url"
                                                                          placeholder="Youtube Url"
                                                                          name="youtubeLink"
                                                                          value={fieldsData.youtubeLink}
                                                                          initValue={this.currentData?.youtubeLink}
                                                                          error={errors['youtubeLink']}
                                                                          maxLength={50}
                                                                          // required={true}
                                                                          onChange={this.getInputValues}/>}

                <InputGroup inputType={'wrapper'}
                            label={'Ամսաթիվը'}
                            error={errors.date}
                            required={true}>
                    <DatePicker value={fieldsData.date}
                                showTime={{format: 'HH:mm'}}
                                format="DD/MM/YY HH:mm"
                                placeholder={'DD/MM/YYYY'}
                                showToday={false}
                                allowClear={false}
                        // disabledDate={(date) => disabledEndDate(date, dayjs())}
                                className={`input-time ${errors.date ? 'error' : ""}`}
                                onChange={(value) => this.getInputValues({
                                    name: "date",
                                    value: value,
                                    haveChanges: true
                                })}/>
                </InputGroup>


                {/*<div className={'socials-wrapper'}>
                    <label>Սոցիալական հղումներ </label>
                    <div className={'add-row'}>
                        <LinkButton title="Ավելացնել"
                                    className={`media-select-btn`}
                                    cb={this.addSocialItem}/>
                    </div>
                    {items && items.length !== 0 &&
                    <Nestable
                        items={items}
                        maxDepth={1}
                        onChange={this.onSocialPositionChange}
                        renderItem={this.socialItem}
                    />}
                         {!!fieldsData.socials.length && fieldsData.socials.map(social=>{
                        return <div className={'social-item'}>

                        </div>
                    })}
                </div>*/}

                <LanguageTabs changeLanguageTab={this.changeLanguageTab}
                              errorsTabs={errorsTabs}
                              activeTab={languageTab}/>
                <div className="blog-wrapper">
                    <InputGroup inputType="input"
                                type="text"
                                label="Անվանում"
                                placeholder="Անվանում"
                                name="title"
                                value={currentData.title}
                                initValue={initData.title}
                                error={errors['title' + languageTab]}
                                maxLength={256}
                                required={true}
                                onChange={this.getTranslationValues}/>
                    <InputGroup inputType="input"
                                type="text"
                                label="Ենթաանվանում"
                                placeholder="Ենթաանվանում"
                                name="subTitle"
                                value={currentData.subTitle}
                                initValue={initData.subTitle}
                                error={errors['subTitle' + languageTab]}
                                required={false}
                                onChange={this.getTranslationValues}/>
                    <div className="editor-wrapper">
                        <label>Նկարագրություն</label>
                        <Editor value={currentData?.description || ''}
                                languageTab={languageTab}
                                name={'description'}
                                initValue={initData?.description}
                                error={errors['description' + languageTab]}
                                onChange={this.getTranslationValues}/>
                    </div>

                </div>

                <div className="flex-wrapper-right">
                    <LinkButton title={!isEditing ? 'Ավելացնել' : 'Փոփոխել'}
                                loading={requestLoading}
                                disabled={isEditing && !this.updatedDataMap.size}
                                cb={this.addEditBlog}/>
                </div>

            </section>
            <MediaSelectorModal
                isOpen={!!mediaModalType}
                acceptTypes={mediaModalType === "video" ? ACCEPT_VIDEO_TYPES : ACCEPT_IMAGE_TYPES}
                mediaType={mediaModalType === "medias" ? MEDIA_MODAL_TYPES.MEDIA_ARRAY : MEDIA_MODAL_TYPES.MEDIA_MAIN}
                appendMedias={mediaModalType === "medias" && fieldsData.medias}
                getMedia={this.getMedia}
                closeModal={this.toggleMediaModal}
            />
        </PageWrapper>
    }
}

const mapDispatchToProps = {
    GetBlogById,
    AddBlog,
    UpdateBlog,
};

export default connect(mapStateToProps, mapDispatchToProps)(AddEditBlog)
